import { render, staticRenderFns } from "./LaporanPelunasan.vue?vue&type=template&id=5b31d4c5&scoped=true&"
import script from "./LaporanPelunasan.vue?vue&type=script&lang=js&"
export * from "./LaporanPelunasan.vue?vue&type=script&lang=js&"
import style0 from "./LaporanPelunasan.vue?vue&type=style&index=0&id=5b31d4c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31d4c5",
  null
  
)

export default component.exports